// import { Dispatch, Action } from 'redux'

import { HistoryCardMapDispatchReturnType } from './types'

export const HistoryCardMapDispatch = (): // dispatch: Dispatch<Action>
HistoryCardMapDispatchReturnType => {
  return {}
}
